import { Auth } from "aws-amplify";

function isLoggedIn() {
  return localStorage.getItem("idToken") !== null && !isTokenExpired();
}

function isTokenExpired() {
  let token = localStorage.getItem("idToken");

  if (token === null) return false;
  let payload = token.split(".")[1];
  let expiration = JSON.parse(atob(payload)).exp;
  return parseInt(new Date().getTime() / 1000) > expiration;
}

function logout() {
  localStorage.clear();
  Auth.signOut();
  document.location.href = "/";
}

export { isLoggedIn, isTokenExpired, logout };
